/* @flow */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as React from 'react';

import UploadButton from 'components/UploadButton.jsx';
import type { UploadRequestData } from 'reducers/fileUploads';
import { loadThumbnail, uploadRequest } from 'reducers/fileUploads';
import { OrderedMap } from 'immutable';

/**
 * ## Wraps UploadButton with
 * ### State managed in redux reducers/fileUploads.js
 *
 * ```example
 * <ReduxUploadButton>
 *  Click here to upload file
 * </ReduxUploadButton>
 * ```
 */

type Props = {
  onClick?: any,
  children?: React.Node,
  fileContextKey: string,
  onUploadStart?: Function,
  onSuccess?: Function,
  onFailure?: Function,
  privateUpload?: boolean,

  /* Redux props */
  fileUploads: OrderedMap<string, UploadRequestData>,
  uploadRequest: Function,
  loadThumbnail?: Function,
};

export class ReduxUploadButton extends React.Component<Props> {
  render() {
    const { children, fileContextKey, fileUploads, privateUpload, ...rest } = this.props;
    return (
      <UploadButton
        fileContextKey={fileContextKey}
        uploadRequest={this.props.uploadRequest}
        disabled={!fileUploads.isEmpty()}
        privateUpload={privateUpload}
        {...rest}>
        {children}
      </UploadButton>
    );
  }
}

const mapStateToProps = (state: Object, props: Object) => {
  const { fileUploads } = state;
  const fileGroup = fileUploads.get(props.fileContextKey);
  return {
    fileUploads: fileGroup || new OrderedMap(),
  };
};

const mapDispatchToProps = (dispatch: Function) =>
  // $FlowIssue
  bindActionCreators(
    {
      uploadRequest,
      loadThumbnail,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReduxUploadButton);
